(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[335],{

/***/ 8105:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact",
      function () {
        return __webpack_require__(9144);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Contact; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var components_MetaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8992);
/* harmony import */ var strapi_api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1014);
/* harmony import */ var components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7603);
/* harmony import */ var components_Elements_Container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4721);
/* harmony import */ var components_Elements_ButtonTicker__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony import */ var _typeform_embed_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2606);
/* harmony import */ var _typeform_embed_react__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_typeform_embed_react__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5935);









var __N_SSG = true;
function Contact(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_MetaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: props.content.meta_info && props.content.meta_info.meta_title ? props.content.meta_info.meta_title : "CONTACT",
                description: props.content.meta_info && props.content.meta_info.meta_description ? props.content.meta_info.meta_description : "Contact - ZANAD | An Independent Animation Production Studio",
                image: props.content.meta_info && props.content.meta_info.og_image ? strapi_api__WEBPACK_IMPORTED_MODULE_8__/* ["default"].getNextImage */ .Z.getNextImage(props.content.meta_info.og_image, "large") : "/public/og-image.jpg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("main", {
                className: "mb-44",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Elements_Container__WEBPACK_IMPORTED_MODULE_4__/* .ContainerWithOffset */ .jZ, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "offscreen-title ",
                            children: "Contacts"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "grid grid-cols-1 gap-10 1024:grid-cols-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                    className: "mt-8 uppercase fluid-type",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "block",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                    num: 4,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "optical-align letter-r",
                                                        children: "Ready "
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                    num: 1,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "",
                                                        children: "to "
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                    num: 3,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "",
                                                        children: "get"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "block text-right 1024:text-left",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                    num: 2,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "optical-align letter-y",
                                                        children: "your "
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                    num: 5,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "",
                                                        children: "idea "
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                            className: "block indent-0 1024:indent-20 1024:indent-36",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                    num: 6,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "",
                                                        children: "“moving”"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                    num: 2,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "",
                                                        children: "?"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mt-4 1024:mt-16 1280:mt-16 1440:mt-28",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_typeform_embed_react__WEBPACK_IMPORTED_MODULE_6__.PopupButton, {
                                            id: "NHTrYKkM",
                                            className: "block btn-ticker-full whitespace-nowrap rounded-[50%] bg-black border-black border-[3px] fluid-type-small-v2 text-white uppercase overflow-hidden mb-10",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "btn-ticker-inner-v2",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    "data-text": "Let's Spark ",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                                            className: "not-italic glyph-icon",
                                                            children: "0"
                                                        }),
                                                        "Let's Spark",
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                                            className: "not-italic glyph-icon",
                                                            children: "0 "
                                                        }),
                                                        "Let's Spark",
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                                            className: "not-italic glyph-icon",
                                                            children: "0 "
                                                        }),
                                                        "Let's Spark",
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                                            className: "not-italic glyph-icon",
                                                            children: "0 "
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "grid grid-cols-1 gap-4 uppercase 640:grid-cols-3 content-with-glyphs text-contacts",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: props.content.conversation ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(props.content.conversation) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    children: props.content.careers ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(props.content.careers) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [606,774,888,179], function() { return __webpack_exec__(8105); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);